module.exports = __webpack_public_path__ + "img/11.5b4407e9.png";